import React, {useContext, useState, useEffect} from 'react'

import {DataContext} from '../../dataContext'
import { useParams } from 'react-router'

import MajorityMeter from '../../utilities/MajorityMeter'
import Declaration from '../../utilities/Declaration'
import LiveUpdates from '../../utilities/LiveUpdates';
import YearButtons from '../../utilities/YearButtons';
import getColorOverride from '../../utilities/functions';

import Party from '../../utilities/Party';
import SeatMap from '../../utilities/SeatMap';

export default function App() {
    const {data} = useContext(DataContext)
	const [seats, setSeats] = useState([])
	const [parties, setParties] = useState([])

	const {results} = data
    const {prov, year} = useParams()

    useEffect(()=> {
        if (results.party) {
			let total = 0
			setSeats([])
			setParties([])
            results.party.partyResults.sort((a,b)=>{
				if (a.seats > b.seats) {
					return -1
				} else if (a.seats < b.seats) {
					return 1
				} else return 0
			}).map((party, i)=>{
				const override = getColorOverride(party.nameShort, `${prov}_${year}`)
				for (let j=0; j<party.elected; j++) {
					total++
                    setSeats( oldArray=> [ ...oldArray, { party: party.nameShort, leading: false,  id: j, color: override? override.color : party.color }])
				}
				for (let j=0; j<party.leading; j++) {
					total++
                    setSeats( oldArray=> [ ...oldArray, { party: party.nameShort, leading: true,  id: j, color: override? override.color : party.color }])
				}
				if (i <=results.party.partyResults.length-1 && i >4) {
					if (!party.seats) {
						return;
					}
				}
				setParties(oldArray=>[...oldArray, {partyName: party.nameShort,id:i, seats: party.seats, text: override?override.font: 'white', color: override? override.color : party.color,votesPercent: party.votesPercent,votesTotal: party.votes}])
				
			})
			if (total < data.config.seats) {
				for (let k=0; k<data.config.seats-total; k++) {
					setSeats( oldArray=> [ ...oldArray, { party: 'none', id: k, color: '#e0e0e0' }])
				}
			}
		}
	}, [results])

	const Seat = (props) => {
		return (
			<div key={`${props.party}-${props.el}`} className={'classes.seat'} style={{backgroundColor: props.color}} />
		);
	}


	// data, longText, seatTotal, majority, limit
    return (
        <div className={'classes.seatApp h-full max-h-maxApp relative background-app '}>
			{(results.party && seats && parties) && 
			<div className={'classes.main flex flex-col h-full gap-1'} aria-labelledby="widgetTitle" tabIndex={0}>
				<div className={'classes.titleRow flex gap-1'} id="widgetTitleRow">
					<div className={'classes.left self-center flex-grow'}>
						<div className={'classes.titleDiv flex justify-between'}>
							<h2 id="widgetTitle" className={'classes.title text-xl sm:text-3xl font-bold'}>{data.config.title}</h2>
							{data.config.currentyear && <YearButtons />}
						</div>
						<Declaration declaration={results.declaration} majority={data.config.majority} showLeading={true} />
					</div>
					{<div className={'classes.majorityMeter min-w-[20%] pt-5 pr-3'}>
						<MajorityMeter limit={true} longText={false} seatTotal={data.config.total} majority={data.config.majority} data={results.party}/>
					</div>}
				</div>
				<div className={'classes.seatContainer flex flex-col flex-grow relative overflow-hidden'}>
					<SeatMap seats={seats} />
				</div>
				<div className={'classes.partyMap flex align-middle gap-1 my-auto'}>
					{parties.map(party=>{
						return <Party key={party.id} party={party}/>
					})}
				</div>
				{data.config.election_day &&
					<LiveUpdates className={''} time={results.party.generated} />
				}
		    </div>}
        </div>
    )
}
